module.exports = __webpack_public_path__ + "img/head2.bccf6686.png";